/**
 * RYZE · THE REVIEWS FOLD (dev2.17-reviews-fold, 3 Nov 2026, RYZE_Part68_A)
 * ──────────────────────────────────────────────────────────────────────────
 * The owner, from the Beyond Vanilla page on his iPhone: "the text Show more
 * in the iPhone look, and the fading effect behind it, perfect this fully,
 * and the desktop version too."
 *
 * Judge.me's review widget 2.0 lays the cards out as a masonry
 * (section.jdgm-masonry-grid, overflow hidden, an inline max-height Vue owns)
 * and folds them with its own sticky footer: a 150 px white fade and an
 * Arial "Show more" that reveals one more screen per tap and vanishes at the
 * end (no Show less, no count, the cut landing anywhere). This script lays
 * the house fold over that markup, Apple's App Store construction:
 *
 *   - THE FOLD LINE lands on purpose: phones show three whole cards and the
 *     head of the fourth (72 px: the stars and the name, fading); desktops
 *     show two whole rows and the head of the third. A fold exists only
 *     when at least two cards would hide; fewer, and the list simply shows.
 *   - THE SCRIM is the page's own paper (#FFFFFF) rising over the last
 *     112 px of the fold, so the cut reads as intended, never mid-word by
 *     accident; it fades out as the list opens.
 *   - THE CONTROL is the house text link under the list, outside the clip:
 *     body face, 0.84rem / 500 / 0.02em, ink, a 1.5-stroke chevron that
 *     turns 180 degrees, a 44 px tap box, aria-expanded + aria-controls,
 *     keyboard and the ONE RING LAW (an ink outline, never gold). It counts:
 *     "Show 12 more reviews", then "Show less".
 *   - THE MOTION: max-height eased 420 ms (cubic-bezier .2 0 0 1) from the
 *     fold to the measured height, then released to none; Show less eases
 *     back to the same fold and scrolls the list's head back under the
 *     header so the fold never collapses out of view. Reduced motion: no
 *     animation, the same states.
 *
 * Judge.me keeps its masonry engine, its sort, its tabs and its state: the
 * widget's own footer is hidden by CSS only while this fold is armed
 * (.ryze-fold on the grid), so if this script never runs, the app's fold
 * works as before (a safe failure). A re-render (a sort, a tab) hands the
 * observer a new grid and it arms again. The stylesheet block is at the
 * foot of ryze-custom.css (W-REVIEWS-FOLD). Loaded by
 * sections/main-product.liquid (product template only).
 */
(function () {
  'use strict';
  if (window.__ryzeRevFold) return;
  window.__ryzeRevFold = true;

  var GRID = '.jdgm-masonry-grid';
  var CONT = '.jdgm-masonry-grid__container';
  var CARD = '.jdgm-review-card';
  var PHONE_ROWS = 3;      /* whole cards shown on a phone (one column) */
  var DESK_ROWS = 2;       /* whole rows shown from 750 (the masonry columns) */
  var PEEK = 72;           /* px of the first hidden row that shows under the scrim: the stars and the name */
  var MIN_HIDDEN = 2;      /* a fold needs at least this many hidden cards */
  var EASE_MS = 420;
  var uid = 0;
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  /* The masonry's columns: a card belongs to the column whose left edge it shares; the k-th card of a
     column is in "row k". The fold shows k whole rows in every column, so the fold line = the top of the
     earliest (k+1)-th card across the columns + the peek; the hidden count = every card past row k. */
  function columnsOf(grid) {
    var gr = grid.getBoundingClientRect();
    var cards = grid.querySelectorAll(CARD);
    var cols = [];
    for (var i = 0; i < cards.length; i++) {
      var r = cards[i].getBoundingClientRect();
      var left = Math.round(r.left - gr.left);
      var top = Math.round(r.top - gr.top);
      var col = null;
      for (var c = 0; c < cols.length; c++) { if (Math.abs(cols[c].left - left) <= 2) { col = cols[c]; break; } }
      if (!col) { col = { left: left, tops: [] }; cols.push(col); }
      col.tops.push(top);
    }
    for (var k = 0; k < cols.length; k++) cols[k].tops.sort(function (a, b) { return a - b; });
    return cols;
  }

  function foldFor(grid) {
    var cols = columnsOf(grid);
    var k = window.innerWidth < 750 ? PHONE_ROWS : DESK_ROWS;
    var hidden = 0, line = Infinity;
    for (var c = 0; c < cols.length; c++) {
      var t = cols[c].tops;
      if (t.length > k) { hidden += t.length - k; if (t[k] < line) line = t[k]; }
    }
    if (hidden < MIN_HIDDEN || line === Infinity) return null;
    return { px: line + PEEK, hidden: hidden };
  }

  function headerHeight() {
    var h = 0;
    var strip = document.querySelector('.ryze-strip');
    var head = document.querySelector('.header-wrapper') || document.querySelector('sticky-header');
    if (strip) h += strip.offsetHeight || 0;
    if (head) h += head.offsetHeight || 0;
    return h || 96;
  }

  function afterEase(grid, fn) {
    if (reduce.matches) { fn(); return; }
    var done = false;
    function end(e) {
      if (e && e.target !== grid) return;
      if (e && e.propertyName && e.propertyName !== 'max-height') return;
      if (done) return;
      done = true;
      grid.removeEventListener('transitionend', end);
      fn();
    }
    grid.addEventListener('transitionend', end);
    setTimeout(end, EASE_MS + 80);
  }

  function arm(grid) {
    if (grid.__ryzeFold) return;
    var cont = grid.querySelector(CONT);
    if (!cont || !grid.querySelector(CARD)) return;
    if (!cont.getBoundingClientRect().height) return;   /* Vue has not measured the masonry yet */
    grid.__ryzeFold = true;

    var fold = foldFor(grid);
    grid.classList.add('ryze-fold');
    if (!fold) {                                          /* nothing worth hiding: the list simply shows */
      grid.classList.add('ryze-fold--none');
      grid.style.maxHeight = 'none';
      return;
    }

    var id = grid.id || (grid.id = 'ryze-rev-grid-' + (++uid));
    var scrim = document.createElement('div');
    scrim.className = 'ryze-rev-fold__scrim';
    scrim.setAttribute('aria-hidden', 'true');
    grid.appendChild(scrim);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ryze-rev-fold__btn';
    btn.setAttribute('aria-controls', id);
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span class="ryze-rev-fold__label"></span>'
      + '<svg class="ryze-rev-fold__chev" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">'
      + '<path d="M3.5 6l4.5 4.5L12.5 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    grid.insertAdjacentElement('afterend', btn);
    var label = btn.querySelector('.ryze-rev-fold__label');

    var state = { open: false, fold: fold.px, hidden: fold.hidden, easing: false };

    function words() {
      label.textContent = state.open
        ? 'Show less'
        : 'Show ' + state.hidden + ' more ' + (state.hidden === 1 ? 'review' : 'reviews');
      btn.setAttribute('aria-expanded', state.open ? 'true' : 'false');
    }

    function open() {
      state.open = true;
      state.easing = true;
      words();
      grid.classList.add('ryze-fold--open');
      grid.style.maxHeight = grid.scrollHeight + 'px';
      afterEase(grid, function () {
        state.easing = false;
        if (state.open) grid.style.maxHeight = 'none';
      });
    }

    function close() {
      var top = grid.getBoundingClientRect().top + window.scrollY;
      var head = headerHeight();
      state.open = false;
      state.easing = true;
      words();
      grid.classList.remove('ryze-fold--open');
      grid.style.maxHeight = grid.scrollHeight + 'px';     /* a number to ease from */
      void grid.offsetHeight;
      var f = foldFor(grid);
      if (f) { state.fold = f.px; state.hidden = f.hidden; words(); }
      grid.style.maxHeight = state.fold + 'px';
      if (window.scrollY + head > top) {
        window.scrollTo({ top: Math.max(0, top - head - 16), behavior: reduce.matches ? 'auto' : 'smooth' });
      }
      afterEase(grid, function () { state.easing = false; });
    }

    btn.addEventListener('click', function () { if (state.open) close(); else open(); });

    grid.style.maxHeight = state.fold + 'px';
    words();

    /* the masonry re-measures itself (a resize, a late font, a card that grew): the fold follows */
    var relayout = function () {
      if (state.open || state.easing) return;
      var f = foldFor(grid);
      if (!f) return;                                      /* keep the fold rather than flash it away */
      if (f.px !== state.fold || f.hidden !== state.hidden) {
        state.fold = f.px; state.hidden = f.hidden;
        grid.style.maxHeight = state.fold + 'px';
        words();
      }
    };
    if ('ResizeObserver' in window) new ResizeObserver(relayout).observe(cont);
    window.addEventListener('resize', relayout);
  }

  var queued = false;
  function scan() {
    queued = false;
    var grids = document.querySelectorAll(GRID);
    for (var i = 0; i < grids.length; i++) arm(grids[i]);
  }
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(scan);
  }
  function boot() {
    queue();
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if ((r.addedNodes && r.addedNodes.length) || r.type === 'attributes') { queue(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
